import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { amber, green } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';
import styles from './snackbarNotify.module.scss';

let openSnackbarFn;

const customStyles = makeStyles((theme) => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  close: {
    padding: theme.spacing(0.5),
  },
}));

const SnackbarContentWrapper = (props) => {
  const { className, message, onClose, variant, ...other } = props;
  const classes = customStyles();

  return (
    <SnackbarContent
      className={clsx(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="message-id">
          <i className={`fa fa-check ${styles.faCheck}`}></i>
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>,
      ]}
      {...other}
    />
  );
};

class SnackbarNotify extends React.Component {
  state = {
    open: false,
    message: '',
    status: 'info',
  };

  componentDidMount() {
    openSnackbarFn = this.openSnackbar;
  }

  handleSnackbarClose = () => {
    this.setState({
      open: false,
      message: '',
      status: 'info',
    });
  };

  openSnackbar = ({ message, status }) => {
    this.setState({ open: true, message, status });
  };

  render() {
    const { open } = this.state;
    const message = (
      <span
        id="snackbar-message-id"
        dangerouslySetInnerHTML={{ __html: this.state.message }}
      />
    );

    /*** MATERIAL-UI STUFF ****/
    //const classes = customStyles();
    /***********************/

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        className={`${styles.snackbar} ${styles[this.state.status]}`}
        open={open}
        autoHideDuration={6000}
        onClose={this.handleSnackbarClose}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        message={message}
      >
        <SnackbarContentWrapper
          onClose={this.handleSnackbarClose}
          variant={this.state.status}
          message={message}
        />
      </Snackbar>
    );
  }
}

export function openSnackbar({ message, status }) {
  openSnackbarFn({ message, status });
}

export default SnackbarNotify;
